export const COMPANY_ADMIN = 'Company Administrator';
export const COMPANY_USER = 'User';
export const READ_ONLY = 'ReadOnly';

export const AMS_ROLES = new Set([COMPANY_ADMIN, COMPANY_USER, READ_ONLY]);
